/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyProfile
 */
export interface ProxyProfile {
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    proxyGenerator?: ProxyProfileProxyGeneratorEnum;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    type?: ProxyProfileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    resolution?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    rateControl?: ProxyProfileRateControlEnum;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    crf?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    bitrate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    audioBitrate?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    variantsLimit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyProfile
     */
    enableDenseFilmstrip?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyProfile
     */
    enableWatermark?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    watermarkImage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    watermarkPosition?: ProxyProfileWatermarkPositionEnum;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    watermarkOpacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    watermarkSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyProfile
     */
    enableTimecode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    timecodePosition?: ProxyProfileTimecodePositionEnum;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    timecodeOpacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    timecodeSize?: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    lut?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    hotfolderCopyTo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    hotfolderReadFrom?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    hotfolderQueueTimeout?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    hotfolderEncodeTimeout?: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    vantageWorkflowId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfile
     */
    externalTranscoderStagingPath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfile
     */
    externalTranscoder?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum ProxyProfileProxyGeneratorEnum {
    Ffmpeg = 'ffmpeg',
    Hotfolder = 'hotfolder',
    Transkoder = 'transkoder',
    Vantage = 'vantage',
    Noop = 'noop'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileTypeEnum {
    Video = 'video',
    Audio = 'audio',
    Image = 'image',
    Pdf = 'pdf',
    Office = 'office',
    Model = 'model',
    Subtitle = 'subtitle',
    Fcpxml = 'fcpxml',
    Fcpxxml = 'fcpxxml',
    Prproj = 'prproj',
    Aep = 'aep',
    Avp = 'avp'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileRateControlEnum {
    Crf = 'CRF',
    Cbr = 'CBR',
    Vbr = 'VBR'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileWatermarkPositionEnum {
    Tl = 'TL',
    Tr = 'TR',
    Br = 'BR',
    Bl = 'BL',
    C = 'C'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileTimecodePositionEnum {
    Tl = 'TL',
    Tr = 'TR',
    Br = 'BR',
    Bl = 'BL',
    C = 'C'
}

export function ProxyProfileFromJSON(json: any): ProxyProfile {
    return ProxyProfileFromJSONTyped(json, false);
}

export function ProxyProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'proxyGenerator': !exists(json, 'proxy_generator') ? undefined : json['proxy_generator'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'resolution': !exists(json, 'resolution') ? undefined : json['resolution'],
        'rateControl': !exists(json, 'rate_control') ? undefined : json['rate_control'],
        'crf': !exists(json, 'crf') ? undefined : json['crf'],
        'bitrate': !exists(json, 'bitrate') ? undefined : json['bitrate'],
        'audioBitrate': !exists(json, 'audio_bitrate') ? undefined : json['audio_bitrate'],
        'variantsLimit': !exists(json, 'variants_limit') ? undefined : json['variants_limit'],
        'enableDenseFilmstrip': !exists(json, 'enable_dense_filmstrip') ? undefined : json['enable_dense_filmstrip'],
        'enableWatermark': !exists(json, 'enable_watermark') ? undefined : json['enable_watermark'],
        'watermarkImage': !exists(json, 'watermark_image') ? undefined : json['watermark_image'],
        'watermarkPosition': !exists(json, 'watermark_position') ? undefined : json['watermark_position'],
        'watermarkOpacity': !exists(json, 'watermark_opacity') ? undefined : json['watermark_opacity'],
        'watermarkSize': !exists(json, 'watermark_size') ? undefined : json['watermark_size'],
        'enableTimecode': !exists(json, 'enable_timecode') ? undefined : json['enable_timecode'],
        'timecodePosition': !exists(json, 'timecode_position') ? undefined : json['timecode_position'],
        'timecodeOpacity': !exists(json, 'timecode_opacity') ? undefined : json['timecode_opacity'],
        'timecodeSize': !exists(json, 'timecode_size') ? undefined : json['timecode_size'],
        'lut': !exists(json, 'lut') ? undefined : json['lut'],
        'hotfolderCopyTo': !exists(json, 'hotfolder_copy_to') ? undefined : json['hotfolder_copy_to'],
        'hotfolderReadFrom': !exists(json, 'hotfolder_read_from') ? undefined : json['hotfolder_read_from'],
        'hotfolderQueueTimeout': !exists(json, 'hotfolder_queue_timeout') ? undefined : json['hotfolder_queue_timeout'],
        'hotfolderEncodeTimeout': !exists(json, 'hotfolder_encode_timeout') ? undefined : json['hotfolder_encode_timeout'],
        'vantageWorkflowId': !exists(json, 'vantage_workflow_id') ? undefined : json['vantage_workflow_id'],
        'externalTranscoderStagingPath': !exists(json, 'external_transcoder_staging_path') ? undefined : json['external_transcoder_staging_path'],
        'externalTranscoder': !exists(json, 'external_transcoder') ? undefined : json['external_transcoder'],
    };
}

export function ProxyProfileToJSON(value?: ProxyProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'proxy_generator': value.proxyGenerator,
        'type': value.type,
        'resolution': value.resolution,
        'rate_control': value.rateControl,
        'crf': value.crf,
        'bitrate': value.bitrate,
        'audio_bitrate': value.audioBitrate,
        'variants_limit': value.variantsLimit,
        'enable_dense_filmstrip': value.enableDenseFilmstrip,
        'enable_watermark': value.enableWatermark,
        'watermark_image': value.watermarkImage,
        'watermark_position': value.watermarkPosition,
        'watermark_opacity': value.watermarkOpacity,
        'watermark_size': value.watermarkSize,
        'enable_timecode': value.enableTimecode,
        'timecode_position': value.timecodePosition,
        'timecode_opacity': value.timecodeOpacity,
        'timecode_size': value.timecodeSize,
        'lut': value.lut,
        'hotfolder_copy_to': value.hotfolderCopyTo,
        'hotfolder_read_from': value.hotfolderReadFrom,
        'hotfolder_queue_timeout': value.hotfolderQueueTimeout,
        'hotfolder_encode_timeout': value.hotfolderEncodeTimeout,
        'vantage_workflow_id': value.vantageWorkflowId,
        'external_transcoder_staging_path': value.externalTranscoderStagingPath,
        'external_transcoder': value.externalTranscoder,
    };
}


